import { SettingsHttpService } from './settings.http.service';

// tslint:disable-next-line: max-line-length
export const appSettingsFactory = (settingsHttpService: SettingsHttpService): Function => () => settingsHttpService.initializeApp();
